export const emailPattern =
  '^[A-Za-z0-9]+(?:[._%+\\-][A-Za-z0-9]+)*_?@[A-Za-z0-9]+(?:[A-Za-z0-9\\-]*[A-Za-z0-9])?(?:\\.[A-Za-z0-9]+(?:[A-Za-z0-9\\-]*[A-Za-z0-9])?)*\\.[A-Za-z]{2,}$';

export const accountNumberPattern = '^\\d+$';

export const trusteeNamePattern = '^.+$';
